import axios from "axios";

export const baseClient = () => {
  return axios.create();
};

export const authClient = () => {
  return axios.create({
    withCredentials: true,
  });
};

const PRO =
  process.env.NODE_ENV === "production" || process.env.NODE_ENV === "pro";

// En local, REACT_APP_LOCAL_API_URL permite usar otro puerto (4001 puede estar ocupado)
const LOCAL_API = process.env.REACT_APP_LOCAL_API_URL || "http://localhost:4001/api";

export const API = PRO ? "https://api.tipify.tips/api" : LOCAL_API;

export const SERVER_URL = PRO
  ? "https://api.tipify.tips"
  : LOCAL_API.replace(/\/api$/, "");
